<template>
    <div style="z-index: 999999999!important;">
        <!-- Modal -->
        <v-dialog v-model="modalInfo.show" max-width="430px" style="z-index: 999999999!important;">
            <v-card class="modal--tips4y">
                <v-card-title class="headline d-flex justify-center">
                    <h2 class="mb-0">{{modalInfo.title}}</h2>
                </v-card-title>

                <v-card-text >
                    <span>{{modalInfo.message}}</span>
                    <template>
                        <v-icon style="font-size: 5rem;" class="d-block text-center remove-pseudo-after" :color="modalInfo.iconColor">
                            {{modalInfo.iconName}}
                        </v-icon>
                    </template>
                </v-card-text>

                <v-card-actions :class="'justify-center'">
                    <v-btn style="text-transform: capitalize" class="primary-button" text @click="onClickOk">
                        {{$t('ok')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Modal -->
    </div>
</template>

<script>

export default {
    computed: {
        modalInfo: {
            get() {
                return this.$store.getters['informationModal/getInformationModalState']
            },
            set(value) {
                this.$store.commit('informationModal/setModalShow', value)
            }
        },
    },

    methods: {
        onClickOk() {
            this.$store.commit('informationModal/setModalShow', false);
            this.$store.commit("loadings/setStateLoadingTemplate", false);
            this.$store.commit("loadings/setStateLoadingMain", false);
            this.$store.commit("loadings/setStateLoadingSidebar", false);
            if(this.modalInfo.statusCode == 401) {
                localStorage.removeItem('@datadrive:token');
                localStorage.removeItem('@datadrive:refreshToken');
                localStorage.removeItem('@datadrive:initialState');
                localStorage.removeItem('@shoppingCartTotals');
                this.$cookies.remove('token', { secure: true, expires: 1 });
                this.$store.commit('auth/setState', {});
                if(this.modalInfo.routerName !== 'login') {
                    this.$router.push('/');
                }
            }
        }
    }
}
</script>

<style lang="scss">
@import '@sass/_variables.scss';

.v-dialog{
    border-radius: 25px !important;
    .modal--tips4y {
        .box__texts {
            padding: 10px 0;
            .row--texts {
                margin: 10px 0;

                .items-texts {
                    margin: 15px 0 20px;

                    p {
                        margin: 0 !important;
                        font-size: 14px;
                        font-family: Lato;
                        line-height: 1.1em;
                        font-weight: 400;
                        color: $grey-dark;

                        &:last-child {
                            font-size: 12px;
                            line-height: 1.1em;
                            color: $grey;
                        }
                    }
                }
            }
        }
    }
    .icon-close {
        position: absolute;
        top: 5px;
        right: 15px;
        cursor: pointer;
    }

    .danger-button {
        border: 1px solid #D90B3B;

        font-weight: 600;
        color: #D90B3B !important;
        border-radius: 43px;
        &:hover{
            background: #D90B3B;
            color: #fff !important;
        }
    }
    .primary-button{
        border: 1px solid var(--v-primary-base);

        font-weight: 600;
        color: var(--v-primary-base) !important;
        border-radius: 43px;
        &:hover{
            background: var(--v-primary-base);
            color: #fff !important;
        }
    }
    .v-btn{
        min-width: 100px;
        &.v-btn--disabled{
            border-color: rgba(0,0,0,.26)!important;
        }
    }
}
</style>
